import React, {
    createContext,
    Dispatch,
    FC,
    ReactNode,
    useEffect,
    useReducer,
} from "react"
import {
    AppState as NativeAppState,
    AppStateStatus as NativeAppStateStatus,
} from "react-native"
import {
    Action,
    AppActionType,
    appReducer,
    AppState,
    initialState,
} from "./AppReducer"
import Logger from "@services/logger"

interface AppProviderProps {
    children: ReactNode
}

type AppAction = Dispatch<Action>

interface AppContextType {
    appState: AppState
    appDispatch: AppAction
}

const AppContext = createContext<AppContextType>({
    appState: initialState,
    appDispatch: () => initialState,
})

const AppProvider: FC<AppProviderProps> = ({ children }) => {
    const [appState, appDispatch] = useReducer(appReducer, initialState)

    const handleStateChange = (status: NativeAppStateStatus) => {
        Logger.info(`APP STATE: ${status}`)
        appDispatch({
            type: AppActionType.APP_STATE,
            payload: { appState: status },
        })
    }

    useEffect(() => {
        Logger.info("APP STARTUP")
        const subscription = NativeAppState.addEventListener(
            "change",
            handleStateChange,
        )
        return () => {
            subscription.remove()
        }
    }, [])

    return (
        <AppContext.Provider value={{ appState, appDispatch }}>
            {children}
        </AppContext.Provider>
    )
}

export { AppContext, AppProvider, AppAction }
